var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"layout-container"},[_c('el-header',[_c('navtop')],1),_vm._v(" "),_c('el-container',{staticClass:"main-container"},[_c('leftNav',{attrs:{"isCollapse":_vm.isCollapse},on:{"toggleCollapse":function($event){_vm.isCollapse = !_vm.isCollapse}}}),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ef71bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/layout.vue
// module id = null
// module chunks = 